import { render } from "./VideoHeader.vue?vue&type=template&id=7f5da742&scoped=true"
import script from "./VideoHeader.vue?vue&type=script&lang=js"
export * from "./VideoHeader.vue?vue&type=script&lang=js"

import "./VideoHeader.vue?vue&type=style&index=0&id=7f5da742&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5da742"]])

export default __exports__